<script setup>
    import { ref } from 'vue'

    const { data } = await useStatamicEntries().getEntryBySlug({
        collection: 'pages',
        value: 'home',
    })

    const container = ref(null)
</script>

<template>
    <div>
        <div class="section-banner">
            <img :src="data.banner_image?.permalink" />

            <div
                class="section-banner__content container relative z-20 mx-auto text-center text-white"
            >
                <h1 class="text-4xl">{{ data.banner_title }}</h1>
                <p class="mt-2 leading-tight">{{ data.banner_content }}</p>
            </div>

            <div
                v-if="data.banner_foreground_image"
                class="banner-foreground-image"
            >
                <img :src="data.banner_foreground_image?.permalink" />
            </div>

            <div v-if="data.banner_cta_active" class="call-to-action ">
                <div class="cta-icon mr-6 flex lg:w-20 shrink-0 items-center">
                    <img
                        src="@/assets/images/car-offer.svg"
                        class="object-contain"
                        alt="Special Offer Image"
                    />
                </div>
                <div class="flex items-center justify-between gap-4 w-full md:block md:w-auto">
                    <p class="cta-text">{{ data.banner_cta_text }}</p>
                    <PrettyButton
                        :href="data.banner_cta_link"
                        class="w-auto inline-flex bg-brand2 border-brand2 shrink-0 text-white md:mt-2 text-xs sm:text-sm md:text-lg md:leading-4 hover:bg-white hover:text-brand2"
                        >{{ data.banner_cta_button_label}}</PrettyButton
                    >
                </div>
            </div>
        </div>

        <div ref="container" name="content">
            <NuxtPage />

            <div class="container mt-10">
                <FaqListing />
            </div>
        </div>

        <div class="py-md mt-md bg-light">
            <ClientOnly>
                <component
                    is="script"
                    type="text/javascript"
                    src="https://reputationhub.site/reputation/assets/review-widget.js"
                ></component>
                <iframe
                    class="lc_reviews_widget"
                    src="https://reputationhub.site/reputation/widgets/review_widget/OpgVNfizBtgri82xaExv"
                    frameborder="0"
                    scrolling="no"
                    style="min-width: 100%; width: 100%"
                ></iframe>
            </ClientOnly>
        </div>
    </div>
</template>

<style scoped>
    .container {
        scroll-margin: calc(var(--header-height) + 1rem);
    }

    .section-banner {
        --bottom-height: clamp(1rem, -0.231rem + 6.838vw, 5rem);

        position: relative;
        max-height: 1200px;
        min-height: 300px;

        background-color: #5d635a;

        &__content {
            position: relative;
            z-index: 20;
        }

        button {
            bottom: var(--bottom-height);
            left: 50%;
            transform: translate(-50%, 50%);
        }

        .banner-foreground-image {
            @apply absolute z-10 w-[45vw];
            left: var(--padding);
            top: 50%;
            transform: translateY(-50%);
        }

        > img {
            position: absolute;
            inset: 0;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

        .call-to-action {
            @apply z-20 flex items-start absolute top-0 left-0 overflow-hidden py-2 max-w-full w-full before:absolute before:inset-0 before:bg-white before:opacity-60 before:-z-10;
            animation: slide-in-from-top .75s ease forwards;
            padding-inline:var(--padding);

            .cta-text {
                @apply font-bold;
                font-size: 0.6rem;
            }

            @media(width >= 480px) {
                @apply px-6 py-4;

                .cta-text {
                    @apply text-xs;
                }
            }
        }

        .cta-icon {
            width:clamp(30px, 7vw, 100px);
        }

        @screen sm {
            > img {
                position: relative;
                object-fit: contain;
                width: 100%;
                inset: auto;
            }

            .call-to-action .cta-text {
                @apply text-sm;

            }
        }

        @screen md {
            .call-to-action {
                @apply z-20 flex items-center absolute top-5 left-auto right-0 overflow-hidden px-4 py-3 rounded-l-full max-w-[300px] before:absolute before:inset-0 before:bg-white before:opacity-60 before:-z-10;
                animation: slide-in-from-left .75s ease forwards;
            }
        }

        @screen lg {
            .call-to-action {
                @apply z-20 flex items-center absolute top-20 right-0 overflow-hidden px-8 py-4 rounded-l-full max-w-[516px] before:absolute before:inset-0 before:bg-white before:opacity-60 before:-z-10;

                .cta-text {
                    @apply text-base;
                }
            }
        }

        @screen xl {
            min-height: 0;
            height: calc(100vh - var(--header-height));
            padding-top: 12vh;

            > img {
                position: absolute;
                inset: 0;
                object-fit: cover;
                width: 100%;
                height: 100%;
            }

            .banner-foreground-image {
                @apply absolute z-10 w-[31vw];
                left: 10vw;
            }
        }
    }

    @keyframes slide-in-from-top {
        0% {
            opacity: 0;
            transform: translateY(-100%);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }

    }

    @keyframes slide-in-from-left {
        0% {
            opacity: 0;
            transform: translateX(100%);
        }
        100% {
            opacity: 1;
            transform: translateX(0);
        }

    }
</style>
